import { motion } from "framer-motion";
import { AlertTriangle, ChevronLeft, CheckCircle2, Loader2 } from "lucide-react";

export default function TimeoutState({ 
  applicationId, 
  isManualVerifying, 
  onManualVerify, 
  onNavigate 
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
      className="text-center"
    >
      <h1 className="mb-2 text-3xl font-bold text-gray-900 sm:text-4xl">
        Payment Verification Timeout
      </h1>

      {applicationId && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="mb-8 px-2 text-sm font-medium text-gray-600 break-all min-w-0 max-w-full"
        >
          Application ID: <span className="font-mono font-semibold">{applicationId}</span>
        </motion.p>
      )}

      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 0.3, type: "spring", stiffness: 200 }}
        className="flex justify-center mb-6"
      >
        <div className="relative">
          <div className="flex justify-center items-center w-32 h-32 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full border-4 border-yellow-300 shadow-xl">
            <AlertTriangle size={64} className="text-white drop-shadow-lg" />
          </div>
          <motion.div
            animate={{ scale: [1, 1.1, 1] }}
            transition={{ duration: 2, repeat: Infinity }}
            className="absolute inset-0 bg-yellow-400 rounded-full opacity-20"
          />
        </div>
      </motion.div>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
        className="mb-2 text-lg font-semibold text-gray-900"
      >
        Payment verification failed after multiple attempts.
      </motion.p>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
        className="mb-8 text-base text-gray-600"
      >
        If your payment was successful, please confirm it manually to complete your registration.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6 }}
        className="flex flex-col gap-3 justify-center items-center sm:flex-row"
      >
        <motion.button
          onClick={() => onNavigate("/conference-trade-mission")}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="inline-flex gap-2 items-center px-6 py-3 text-sm font-semibold text-gray-700 bg-white rounded-lg border-2 border-gray-300 transition-all hover:bg-gray-50 hover:border-gray-400"
        >
          <ChevronLeft size={18} />
          Back to Events
        </motion.button>

        <motion.button
          onClick={onManualVerify}
          disabled={isManualVerifying}
          whileHover={{ scale: isManualVerifying ? 1 : 1.02 }}
          whileTap={{ scale: isManualVerifying ? 1 : 0.98 }}
          className="inline-flex gap-2 items-center px-6 py-3 text-sm font-semibold text-white bg-gradient-to-r from-yellow-500 to-yellow-600 rounded-lg shadow-xl transition-all hover:from-yellow-600 hover:to-yellow-700 hover:shadow-2xl disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isManualVerifying ? (
            <>
              <Loader2 size={18} className="animate-spin" />
              Processing...
            </>
          ) : (
            <>
              <CheckCircle2 size={18} />
              Confirm Payment Manually
            </>
          )}
        </motion.button>
      </motion.div>
    </motion.div>
  );
}

